<template>
    <div class="m15 page_logo" ref="body" style="page-break-before: always;" id="aposentadoria">
        <hr  class="site" />
        <h4 class="simulator-title loaded">Aposentadoria ou Liberdade Financeira</h4>
        <saudacao :cliente.sync="cliente.pessoa" ref="saudacao" class="saudacao"/>
        <div class="row">
        <div class="col l12 s12">
            <div class="texto" style="text-align:justify">
                Em nosso
                <template v-if="empresa && empresa.empresa_nome_fantasia.toLowerCase().includes('oabprev')">
                    processo de <b style="font-weight:bold;">consultoria da OABPrev-MG</b>
                </template>
                <template v-else>
                    trabalho de <b style="font-weight: bold">consultoria</b>
                </template>,
                um dos principais objetivos é o de auxiliá-lo na formação de uma reserva futura que lhe proporcione a tranquilidade, a <b style="font-weight:bold;">liberdade financeira</b> no momento da sua aposentadoria ou no momento em que você desejar encerrar ou reduzir a sua atividade laborativa.
            </div>
        </div>
        </div>
        <div class="row">
        <div class="col l12 s12">
            <div class="texto" style="text-align:justify">
                É cada vez mais claro que não se pode contar com os sistemas de previdência público, seja ele a Previdência Social ou Previdência Estatutária (estados e municípios). Portanto, a frase dita por Peter Drucker, considerado um dos pais da administração moderna, de que “a melhor maneira de prever o seu futuro é cria-lo”, nunca esteve tão em evidência.
            </div>

            <div class="texto" v-if="empresa && empresa.empresa_nome_fantasia.toLowerCase().includes('oabprev')">
                E nada melhor do que buscar a formação dessa reserva futura através da sua OABPrev, uma entidade sem fins lucrativos, com uma das menores taxas do mercado, excelente histórico de rentabilidade, já que 100% dos resultados são destinados ao participante, nosso acionista, você!
            </div>
        </div>
        </div>
        <div class="row">
        <div class="col l12 s12">
            <div class="texto" style="text-align:justify">
                Você nos informa que para a manutenção do <b style="font-weight:bold;">padrão de vida</b> pretendido no <b style="font-weight:bold;">futuro</b>, a partir de {{ independencia_financeira.idade_aposentadoria }} anos de idade, será necessário ter acesso a uma Reserva Financeira que, investida, lhe proporcione uma renda mensal complementar de aproximadamente {{ independencia_financeira.renda_complementar | dinheiro }} ({{ independencia_financeira.renda_complementar | dinheiro_extenso }}).
            </div>
        </div>
        </div>

        <div class="row">
        <div class="col l12 s12">
            <div class="texto" style="text-align:justify">
                Diante do objetivo acima exposto, temos a seguinte memória de cálculo e lhe apresentamos a necessidade de investimento mensal durante esses {{ anos_contribuicao }} anos de contribuições:
            </div>
        </div>
        </div>

        <div class="row">
        <div class="col l3 x15"></div>
        <div class="col l6 s12 x70">
            <table class="print-table striped">
            <thead>
                <tr class="print-table-text-center">
                    <th scope="col">IDADE ATUAL</th>
                    <th scope="col">IDADE ALVO</th>
                    <th scope="col">RENDA MENSAL PRETENDIDA</th>
                    <th scope="col">RESERVA ESTIMADA NECESSÁRIA</th>
                </tr>
            </thead>
            <tbody>
                <tr class="print-table-text-center">
                    <td data-label="IDADE ATUAL">{{ cliente.pessoa.pessoa_idade }}</td>
                    <td data-label="IDADE ALVO">{{ independencia_financeira.idade_aposentadoria }}</td>
                    <td data-label="RENDA MENSAL PRETENDIDA">{{ independencia_financeira.renda_complementar | dinheiro }}</td>
                    <td data-label="RESERVA ESTIMADA NECESSÁRIA">{{ reserva_necessaria | dinheiro }}</td>
                </tr>
            </tbody>
            </table>
        </div>
        <div class="col l3 x15"></div>
        </div>

        <div class="row">
        <div class="col l3 x15"></div>
        <div class="col l6 s12 x70">
            <table class="print-table striped">
            <thead>
                <tr class="print-table-text-center">
                    <th scope="col">RESERVA ESTIMADA NECESSÁRIA</th>
                    <th scope="col">VALOR PRESENTE CAPITALIZADO</th>
                    <th scope="col">RENTABILIDADE ESTIMADA</th>
                    <th scope="col">APORTE MENSAL NECESSÁRIO</th>
                </tr>
            </thead>
            <tbody>
                <tr class="print-table-text-center">
                    <td data-label="RESERVA ESTIMADA NECESSÁRIA">{{ reserva_necessaria | dinheiro }}</td>
                    <td data-label="VALOR PRESENTE CAPITALIZADO">{{ independencia_financeira.aporte_inicial | dinheiro }}</td>
                    <td data-label="RENTABILIDADE ESTIMADA">{{ independencia_financeira.rentabilidade_estimada }}% ao ano</td>
                    <td data-label="APORTE MENSAL NECESSÁRIO">{{ independencia_financeira.necessidade_investimento | dinheiro }}</td>
                </tr>
            </tbody>
            </table>
        </div>
        <div class="col l3 x15"></div>
        </div>
    </div>
</template>

<script>
    import { get } from "@/helpers/api";
    import { utils } from "../relatorios/mixins/index";
    import Saudacao from './Saudacao'
    export default {
        name: 'LiberdadeFinanceira',
        mixins: [utils],
        data () {
            return {
                x: [],
                titulo: 'Aposentadoria ou Liberdade Financeira'
            }
        },

        computed: {
            independencia_financeira() {
                return this.cliente.independencia_financeira;
            },

            reserva_necessaria() {
                return this.independencia_financeira.renda_complementar * 100 * 0.5;
            },
            anos_contribuicao() {
                return this.independencia_financeira.idade_aposentadoria - this.cliente.pessoa.pessoa_idade;
            }
        },
        components: {
            Saudacao
        },
        props: {
            cliente: {
                type: Object,
                default: null
            },
            empresa: Object,
        },
        methods: {
            async plot(){
                return this.$refs.body.outerHTML;
            },
        }
    }
</script>

<style lang="scss" scoped>
@import "../relatorios/Simulador.scss";
.graph{
    text-align: center;
}
.total{
    font-size: 12px;
}
.block{
    width: 300px;
    margin-left: 120px;
    display: contents;
}
.texto {
    margin-top: 15px;
    margin-bottom: 15px;
}
.m5 {
    margin-top: 15px;
}
th{
    text-align: center;
}
td{
    text-align: center;
}
@media (min-width: 320px) and (max-width: 480px) {
   .block{
        width: 300px;
        margin-left: 25px;
        display: block;
    }
}
@media screen and (max-width: 600px) {
    table {
      border: 0;
    }

    table caption {
      font-size: 1.3em;
    }

    table thead {
      border: none;
      clip: rect(0 0 0 0);
      height: 1px;
      margin: -1px;
      overflow: hidden;
      padding: 0;
      position: absolute;
      width: 1px;
    }

    table tr {
      border-bottom: 3px solid #ddd;
      display: block;
      margin-bottom: .625em;
    }

    table td {
      border-bottom: 1px solid #ddd;
      display: block;
      font-size: .8em;
      text-align: right;
    }

    table td::before {
      /*
      * aria-label has no advantage, it won't be read inside a table
      content: attr(aria-label);
      */
      content: attr(data-label);
      float: left;
      font-weight: bold;
      text-transform: uppercase;
      color: var(--color-primary);
    }

    table td:last-child {
      border-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/graficos-simulador/LiberdadeFinanceira.vue